import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { forwardRef as I, useRef as w } from "react";
import t from "classnames";
import y from "../InputTooltip/index.js";
import D from "../../icons/DeleteCircle.js";
import V from "../../helpers/setNativeInputValue.js";
const z = "forma-ui__field-container__container", A = "forma-ui__field-container__hidden", B = "forma-ui__field-container__fullWidth", E = "forma-ui__field-container__inputContainer", G = "forma-ui__field-container__label", H = "forma-ui__field-container__icons", J = "forma-ui__field-container__icon", K = "forma-ui__field-container__button", L = "forma-ui__field-container__errorText", O = "forma-ui__field-container__notice", P = "forma-ui__field-container__required", n = {
  container: z,
  hidden: A,
  fullWidth: B,
  inputContainer: E,
  label: G,
  icons: H,
  icon: J,
  button: K,
  errorText: L,
  notice: O,
  required: P
}, g = I(({
  id: o,
  children: h,
  required: p,
  fullWidth: N,
  className: b,
  containerClass: x,
  labelClass: C,
  label: a,
  error: T,
  errorMessage: c,
  notice: l,
  buttons: s,
  icon: _,
  tooltip: d,
  tooltipClass: q,
  hidden: R,
  showClearButton: W,
  isShowClear: f,
  isShowButtons: v,
  isShowTooltip: j,
  isShowIcon: k,
  onClear: m
}, r) => {
  const u = r && "current" in r ? r : w(null), F = () => {
    V(o, ""), m && m();
  };
  return /* @__PURE__ */ i("div", { className: t(n.container, N && n.fullWidth, x, R && n.hidden), children: [
    a && /* @__PURE__ */ i("label", { className: t(n.label, C), htmlFor: o, children: [
      a,
      p && /* @__PURE__ */ e("span", { className: n.required, children: " *" })
    ] }),
    /* @__PURE__ */ i("div", { className: t(n.inputContainer, b), ref: u, children: [
      h,
      /* @__PURE__ */ i("span", { className: n.icons, children: [
        f && W && f && /* @__PURE__ */ e("span", { className: n.button, onClick: F, children: /* @__PURE__ */ e(D, {}) }),
        v && s && /* @__PURE__ */ e("span", { className: n.button, children: s }),
        k && _ && /* @__PURE__ */ e("span", { className: n.icon, children: _ })
      ] })
    ] }),
    T && c && /* @__PURE__ */ e("span", { className: n.errorText, children: c }),
    l && /* @__PURE__ */ e("span", { className: n.notice, children: l }),
    d && /* @__PURE__ */ e(
      y,
      {
        id: o,
        show: j,
        controlRef: u,
        className: q,
        children: d
      }
    )
  ] });
});
export {
  g as default
};
